import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddMilestone({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    return (
        <Modal
            className="modal milestone_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Milestone</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Vendor Name */}
                            <div className="control_group">
                                <label htmlFor="vendor-name">
                                    Vendor Name <span>*</span>
                                </label>
                                <TextField
                                    placeholder="Enter vendor name"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "vendor-name" }}
                                />
                            </div>

                            {/* Milestone Type */}
                            <div className="control_group">
                                <label htmlFor="milestone-type">Milestone Type</label>
                                <Select fullWidth defaultValue="achievement" inputProps={{ id: "milestone-type" }}>
                                    <MenuItem value="achievement">Achievement</MenuItem>
                                    <MenuItem value="revenue">Revenue</MenuItem>
                                    <MenuItem value="performance">Performance</MenuItem>
                                </Select>
                            </div>

                            {/* Title */}
                            <div className="control_group">
                                <label htmlFor="milestone-title">
                                    Title <span>*</span>
                                </label>
                                <TextField
                                    placeholder="e.g., $10,000 Revenue"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "milestone-title" }}
                                />
                            </div>

                            {/* Description */}
                            <div className="control_group">
                                <label htmlFor="milestone-description">Description</label>
                                <TextField
                                    placeholder="Details about this milestone..."
                                    fullWidth
                                    multiline
                                    rows={4}
                                    hiddenLabel
                                    inputProps={{ id: "milestone-description" }}
                                />
                            </div>

                            {/* Value */}
                            <div className="control_group">
                                <label htmlFor="milestone-value">Value (if applicable)</label>
                                <TextField
                                    placeholder="e.g., 10000"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "milestone-value" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_light"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>

                            <Button
                                className="btn btn_primary"
                            >
                                Add Milestone
                            </Button>
                        </div>
                    </form>

                </div>
            </div>
        </Modal>
    );
}
